import { render, staticRenderFns } from "./ModernTopbar.vue?vue&type=template&id=3b0f0c42&"
import script from "./ModernTopbar.vue?vue&type=script&lang=js&"
export * from "./ModernTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports